import { render } from "./NSIDataUploading.vue?vue&type=template&id=2cfff4bb&ts=true"
import script from "./NSIDataUploading.vue?vue&type=script&lang=ts"
export * from "./NSIDataUploading.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__